import { addLocale } from "primereact/api";

import pl from "../../locales/pl/calendar.json";
import en from "../../locales/en/calendar.json";
import cz from "../../locales/cz/calendar.json";
import de from "../../locales/de/calendar.json";
import fr from "../../locales/fr/calendar.json";

const calendarLocales = {
  pl,
  en,
  cz,
  de,
  fr
};

export const setupCalendarLocale = (langCode: string) => {
  const lang = langCode.split("-")[0];
  const data = calendarLocales[lang];


  if (data) {
    addLocale(lang, data);
  } else {
    console.warn(`No calendar data for this lang: ${lang}`);
  }
};
